var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('s-button',_vm._b({staticClass:"ssc-button-icon-center",attrs:{"loading":_vm.loading},on:{"click":_vm.handleClick}},'s-button',_vm.$attrs,false),[_vm._t("default",function(){return [_vm._v(_vm._s(_vm.$i18n('Export')))]})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }